import type { DirectoryTagView } from '../features/directory-tags/directory-tags.api';

/** A record stores a tag's code; this is the name to show for it, falling back to the code for an entry the catalogue no longer lists. */
export function tagLabel(tags: DirectoryTagView[], code: string): string {
  return tags.find((tag) => tag.code === code)?.name ?? code;
}

/** What a form's tag picker offers: every active entry, plus any inactive one the record already carries so it still shows. */
export function tagChoices(tags: DirectoryTagView[], carried: string[]): { value: string; label: string }[] {
  return tags.filter((tag) => tag.isActive || carried.includes(tag.code)).map((tag) => ({ value: tag.code, label: tag.name }));
}
